import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from '../../services';
import { EventEmitterService } from '../../services/event-emitter.service';
import { PdaService } from '../../services/pda.service';

@Component({
  selector: 'app-plan-statistics',
  templateUrl: './plan-statistics.component.html',
  styleUrls: ['./plan-statistics.component.scss'],
})
export class PlanStatisticsComponent implements OnInit {
  openStatistic: boolean = false;
  openByMember: boolean = false;
  generalStatistics: any = {};
  byUserStatistics: any;
  @Input() planSelected: any;
  @Input() statisticsReload: any;
  @Output() public emitLoaded = new EventEmitter();

  title: String;
  colorScheme = {
    domain: [
      'whitesmoke',
      'white',
      'yellow',
      'orange',
      'greenyellow',
      'green',
      'blue ',
    ],
  };
  colorSchema = {
    domain: ['#00e800', ' #ff0000 '],
  };
  constructor(
    private translate: TranslateService,
    private pda: PdaService,
    private globals: GlobalsService,
    private el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let lang = this.translate.currentLang;
    if (lang == 'es') {
      this.title = 'Fechas';
    } else {
      this.title = 'Dates';
    }
  }
  ngAfterViewInit() {}
  changeStatistic(): void {
    this.openStatistic = !this.openStatistic;
  }
  changeMembers(): void {
    this.openByMember = !this.openByMember;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.byUserStatistics = [];
    this.generalStatistics = {};
    this.openStatistic = false;
    this.openByMember = false;
    if (this.planSelected.length != 0) {
      this.getStats();
    }
    if(this.statisticsReload.length){
      this.getStats();
    }
     
   
  }
  getStats(){
    
    this.pda.getStatistics(this.planSelected.id).subscribe(
      (res: any) => {
        this.emitLoaded.emit(true);
        res.data.map((x) => {
          x.notificados = Number(x.notificados);
          x.en_ejecucion = Number(x.en_ejecucion);
        });
        this.byUserStatistics = res.data;
        for (let i = 0; i < this.byUserStatistics.length; i++) {}
      },
      (err) => {
        console.log('ERROR AL OBTENER ESTADISTICAS', err);
      }
    );
    this.pda.getStatisticsSummary(this.planSelected.id).subscribe(
      (res: any) => {
        for (var i = 0; i < res.data.length; i++) {
          this.generalStatistics.no_tratado = res.data[i].no_tratado;
          this.generalStatistics.notificados = res.data[i].notificados;
          this.generalStatistics.planificado = res.data[i].planificado;
          this.generalStatistics.en_ejecucion = res.data[i].en_ejecucion;
          this.generalStatistics.ejecutada = res.data[i].ejecutada;
          this.generalStatistics.fecha_validacion =
            res.data[i].fecha_validacion;
          this.generalStatistics.en_fecha = res.data[i].en_fecha;
          this.generalStatistics.no_en_fecha = res.data[i].no_en_fecha;
        }

      },
      (err) => {
        console.log('ERROR AL OBTENER ESTADISTICAS', err);
      }
    );
  }
}
